import request from "@/utils/request";

export function getGrcControls(params) {
  return request({
    url: "/grc-controls",
    method: "get",
    params,
  });
}

export function getGrcControl(id, params) {
  return request({
    url: `/grc-controls/${id}`,
    method: "get",
    params,
  });
}

export function createGrcControl(data, params) {
  return request({
    url: "/grc-controls",
    method: "post",
    data,
    params,
  });
}

export function updateGrcControl(id, data, params) {
  return request({
    url: `/grc-controls/${id}`,
    method: "put",
    data,
    params,
  });
}

export function approveGrcControl(id, data, params) {
  return request({
    url: `/grc-controls/${id}/approve`,
    method: "post",
    data,
    params,
  });
}

export function rejectGrcControl(id, data, params) {
  return request({
    url: `/grc-controls/${id}/reject`,
    method: "post",
    data,
    params,
  });
}

export function deleteGrcControl(id, params) {
  return request({
    url: `/grc-controls/${id}`,
    method: "delete",
    params,
  });
}
